import React, { useEffect, useState } from 'react';
import { Layout, Justify, Segment } from 'tea-component';
import {
  FilterFixed,
  useFilterDataHook,
} from '@/pages/opinion/components/FilterCommon';
import { connect, getLocale, useDispatch } from 'umi';
import CardLoading from '@/pages/opinion/components/CardLoading';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import ChartsBox from '../components/ChartsBox';
import '@/pages/opinion/assets/scss/pages/stats/regionCountry.scss';
import BubbleCommon from '@/pages/opinion/components/BubbleCommon';
import { statsTipsRegionHeaderText } from '@/pages/opinion/components/BubbleCommon/copywritingKey/stats';
import { useInitBuriedPointInfo } from '@/pages/opinion/operationLog/buriedPoint';
import StatsRegionCountryPoint from '@op/operationLog/pages/statsRegion';
import ContentBody from '@/pages/opinion/components/ContentBody';
import { PAGE_NAME } from '@op/constants/page';
import DetailPageTable, { ChannelType } from '@op/components/DetailPageTable';
const { Content } = Layout; 

function RegionCountry({ gameInfo, data, regionLoading, wholeGameInfo }: any) {
  useInitBuriedPointInfo({ buriedPoint: StatsRegionCountryPoint });
  const {
    loading,
    filter,
    changeFilter,
    filterOptions,
    scrollBody,
    changeTopicList,
    topicList,
  } = useFilterDataHook({
    gameInfo,
    pageName: 'Stats_Region',
  });
  const { formatMessage, formatOptionsMessage } = useLanguage();
  const dispatch = useDispatch();
  const [regionType, setRegionType] = useState<any>('region');
  const [channelType, setChannelType] = useState<ChannelType>('social');

  useEffect(() => {
    if (!gameInfo || !filter) return;
    dispatch({
      type:
        regionType === 'region'
          ? 'opinionPerformance/getOverviewRegion'
          : 'opinionPerformance/getOverviewCountry',
      payload: {
        ...filter,
        ...gameInfo,
        statistics_field: 'region',
        region_stats_method: regionType,
        version_time: '1',
      },
    });
  }, [gameInfo, filter, regionType]);

  const isShowHeardTips = getLocale() === 'en-US';

  return (
    <Content className="dbo-regionCountry dbo-stats" ref={scrollBody}>
      <ContentBody
        pageName={PAGE_NAME.REGION_COUNTRY}
        contentHeard={
          <Content.Header
            title={formatMessage({ id: PAGE_NAME.REGION_COUNTRY })}
            subtitle={
              isShowHeardTips && (
                <div className="regionCountry-title">
                  <BubbleCommon tipsMap={statsTipsRegionHeaderText}>
                    <span className="regionCountry-title-desc">
                      {formatMessage({ id: 'Unidentified' })}
                    </span>
                  </BubbleCommon>
                </div>
              )
            }
          />
        }
      >
        <FilterFixed
          filter={filterOptions}
          scrollBody={scrollBody}
          confirm={(value: any) => {
            changeFilter({ ...value, ...gameInfo });
          }}
          backCondOriginData={(value) => {
            changeTopicList({ topic_trans: value.topic_trans, key_topic: {} });
          }}
        ></FilterFixed>
        <Justify
          className="dbo-stats-sgement-justify"
          left={
            <Segment
              className="segment-light"
              value={regionType}
              onChange={(value) => setRegionType(value)}
              options={formatOptionsMessage([
                { text: 'Region', value: 'region' },
                { text: 'Country', value: 'market' },
              ])}
            />
          }
        />
        <CardLoading loading={loading}>
          <ChartsBox
            data={data}
            loading={regionLoading}
            filter={filter}
            dataType="region"
            regionType={regionType}
          ></ChartsBox>
          <DetailPageTable
            hasNews={true}
            channelType={channelType}
            setChannelType={setChannelType}
            gameInfo={gameInfo}
            defaultPageInfo={{ page: 1, page_size: 5 }}
            filter={filter}
            hasPageable={false}
            wholeGameInfo={wholeGameInfo}
          ></DetailPageTable>
        </CardLoading>
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { loading, opinionCommon, opinionPerformance } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    data: opinionPerformance.region,
    regionLoading:
      loading.effects['opinionPerformance/getOverviewRegion'] ||
      loading.effects['opinionPerformance/getOverviewCountry'],
  };
})(RegionCountry);
